import { WifiOff } from 'lucide-react';

export default function NotificacaoErroConexaoERP({ notificacao, onClose }) {
  const d = notificacao.dados;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="bg-gradient-to-r from-red-500 to-orange-500 px-5 py-4 flex items-center gap-3">
          <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <WifiOff className="w-6 h-6 text-red-500" />
          </div>
          <h3 className="text-white font-bold text-base leading-tight">Erro de Conexão com o ERP</h3>
        </div>

        <div className="p-5">
          <p className="text-sm text-gray-700">{d.mensagem}</p>
        </div>

        <div className="px-5 pb-5 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
